import { Project, Service, BlogPost, Testimonial } from '../types';

export const projects: Project[] = [
  {
    id: '1',
    title: 'Мини биллинг система',
    description: 'Система биллинга для Microtik маршрутизаторов. Автоматизация расчетов и управления пользователями.',
    category: 'Телекоммуникации',
    technologies: ['Python', 'FastAPI', 'PostgreSQL'],
    icon: '📱',
    bgColor: 'bg-blue-600',
  },
  {
    id: '2',
    title: 'Платформа управления сервисами',
    description: 'Решение для управления проектами и услугами. Отслеживание статусов, управление командой и клиентами.',
    category: 'Услуги (B2B)',
    technologies: ['Django', 'React', 'PostgreSQL'],
    icon: '🛠️',
    bgColor: 'bg-green-600',
  },
  {
    id: '3',
    title: 'B2B торговая платформа',
    description: 'Платформа для оптовой торговли удобрениями с функциями каталога, управления заказами, документооборотом и интеграцией с 1С.',
    category: 'Торговля (B2B)',
    technologies: ['Python', 'React', '1С'],
    icon: '🛒',
    bgColor: 'bg-orange-600',
  },
];

export const services: Service[] = [
  {
    id: '1',
    title: 'Системный анализ & Консультации',
    description: 'Провожу комплексный анализ бизнес-процессов вашей компании, выявляю узкие места и предлагаю оптимальные IT-решения. Разрабатываю стратегию цифровой трансформации с учетом специфики вашего бизнеса. Помогаю выбрать правильные технологии и инструменты для достижения максимальной эффективности. Оцениваю текущую IT-инфраструктуру и даю рекомендации по ее улучшению и оптимизации расходов.',
    icon: '🔍',
    features: [
      'Аудит текущей инфраструктуры и бизнес-процессов',
      'Разработка комплексной IT стратегии',
      'Оптимизация процессов и снижение затрат',
      'Консультации по выбору технологий',
    ],
  },
  {
    id: '2',
    title: 'Настройка серверов',
    description: 'Профессиональная настройка и администрирование серверов любой сложности. Работаю с облачными платформами (AWS, Yandex Cloud, Timeweb) и локальной инфраструктурой. Настраиваю Windows, Linux серверы для максимальной производительности и безопасности. Организую резервное копирование, мониторинг и автоматизацию рутинных задач. Обеспечиваю высокую доступность и отказоустойчивость систем.',
    icon: '⚙️',
    features: [
      'Облачные решения (AWS, Yandex Cloud, Timeweb)',
      'Локальные серверы (Windows, Linux)',
      'Безопасность и резервное копирование',
      'Мониторинг и автоматизация',
    ],
  },
  {
    id: '3',
    title: 'Внедрение 1С',
    description: 'Полный цикл внедрения и настройки систем 1С для автоматизации бизнес-процессов. Специализируюсь на конфигурациях для торговли, розницы, оптовой торговли, бухгалтерии, производства и сельского хозяйства. Провожу обучение персонала, настраиваю интеграции с внешними системами и обеспечиваю техническую поддержку. Помогаю выбрать подходящую конфигурацию и адаптировать ее под специфику вашего бизнеса.',
    icon: '📊',
    features: [
      'Торговля и розница (1С:Управление торговлей, 1С:Розница)',
      'Бухгалтерия и управление (1С:Бухгалтерия, 1С: УНФ)',
      'Производство и сельское хозяйство',
      'Интеграции и обучение персонала',
    ],
  },
  {
    id: '4',
    title: 'Web-разработка',
    description: 'Создаю современные веб-приложения с использованием актуальных технологий и best practices. Разрабатываю пользовательские интерфейсы на React и TypeScript с учетом UX/UI принципов. Строю надежные backend-системы на FastAPI и Django с использованием PostgreSQL, MySQL и других СУБД. Обеспечиваю полный цикл разработки: от проектирования архитектуры до развертывания и поддержки. Создаю масштабируемые решения для бизнеса любого масштаба.',
    icon: '💻',
    features: [
      'Frontend разработка (React, TypeScript, Tailwind CSS)',
      'Backend разработка (FastAPI, Django, Python)',
      'Полный цикл разработки от идеи до запуска',
      'Интеграции с внешними API и сервисами',
    ],
  },
  {
    id: '5',
    title: 'Проектирование сетей',
    description: 'Профессиональное проектирование и построение сетевой инфраструктуры для предприятий любого масштаба. Разрабатываю архитектуру локальных и распределенных сетей с учетом требований безопасности, производительности и масштабируемости. Планирую топологию сетей, подбираю оборудование, настраиваю маршрутизацию и коммутацию. Обеспечиваю интеграцию с существующей инфраструктурой и подготовку технической документации. Создаю надежные и безопасные сетевые решения, соответствующие современным стандартам.',
    icon: '🌐',
    features: [
      'Проектирование локальных и распределенных сетей',
      'Планирование сетевой топологии и инфраструктуры',
      'Подбор и настройка сетевого оборудования',
      'Техническая документация и схемы',
    ],
  },
];

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Как оптимизировать IT инфраструктуру компании',
    description: 'Практические советы по аудиту и улучшению вашей IT инфраструктуры...',
    category: 'Системный анализ',
    readTime: '5 мин чтения',
    link: '#',
  },
  {
    id: '2',
    title: '1С внедрение: правильный подход',
    description: 'Ошибки которых стоит избегать при внедрении 1С в вашей компании...',
    category: 'Внедрение 1С',
    readTime: '7 мин чтения',
    link: '#',
  },
  {
    id: '3',
    title: 'React + TypeScript: лучшие практики',
    description: 'Как писать чистый и масштабируемый код на React с использованием TypeScript...',
    category: 'Web разработка',
    readTime: '8 мин чтения',
    link: '#',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Иван Петров',
    position: 'Директор',
    company: 'ООО "Спецторг"',
    text: 'Отличный специалист! Помог нам настроить всю инфраструктуру и внедрить 1С. Профессиональный подход и четкое выполнение всех сроков.',
    rating: 5,
  },
  {
    id: '2',
    name: 'Мария Сидорова',
    position: 'Финансовый директор',
    company: '"МегаТек"',
    text: 'Квалифицированный анализ нашей системы и четкие рекомендации. Экономия на инфраструктуре получилась значительной.',
    rating: 5,
  },
  {
    id: '3',
    name: 'Алексей Миронов',
    position: 'CEO',
    company: '"СофтСолюшнз"',
    text: 'Помощь с веб-приложением была крайне полезна. Сразу видно, что работаешь с опытным разработчиком.',
    rating: 5,
  },
];

